import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import Enums from "../../configs/Enums";
import Utils from "../../configs/Utils";

const WorkspaceMemberForm = ({ workspaceId, setPopupShow }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("member"); // default role

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error("User email is required.");
      return;
    }

    setLoading(true);
    try {
      const response = await Utils._apiRequest({
        path: Enums.endpoints.workspace.MEMBER,
        type: "POST",
        payload: {
          workspaceId,
          email,
          role,
        },
      });

      if (response && response.data) {
        toast.success("Member added successfully.");
        setPopupShow(false);
      } else {
        toast.error("Failed to add member.");
      }
    } catch (error) {
      toast.error(
        error.message || "An error occurred while adding the member.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Form.Group className="mb-3" controlId="memberEmail">
        <Form.Label>
          User Email <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter user's email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mb-4" controlId="memberRole">
        <Form.Label>Role</Form.Label>
        <Form.Select value={role} onChange={(e) => setRole(e.target.value)}>
          <option value="member">Member</option>
          <option value="admin">Admin</option>
        </Form.Select>
      </Form.Group>

      <div className="d-flex justify-content-end">
        <Button
          variant="secondary"
          className="me-2"
          onClick={() => setPopupShow(false)}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button variant="primary" type="submit" disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Add Member"}
        </Button>
      </div>
    </Form>
  );
};

export default WorkspaceMemberForm;
